import { priceLabel, priceSourceNote } from '@vtf/shared';
import { fmtR, formatMoney, signClass } from '../lib/format';
import type { TradeMark } from '../lib/types';
import { cx } from './ui';

/**
 * Interim delayed prices (INT-SYN-04, D23): every automatic price carries its source and the source's own time —
 * "Delayed · Yahoo · 14:32", or "Stale · …" past PRICE_STALE_MINUTES. Never "live".
 */
export function PriceLabel({ mark, tz, className }: { mark: Pick<TradeMark, 'source' | 'sourceName' | 'asOf' | 'stale'>; tz: string; className?: string }) {
  return (
    <span className={cx('text-xs whitespace-nowrap', mark.stale ? 'text-warn' : 'text-muted', className)} title={`${priceSourceNote(mark.source, mark.sourceName)}. Quote time in ${tz}.`}>
      {priceLabel(mark, tz)}
    </span>
  );
}

/** Open R (everyone), or the % move without a stop, plus open P&L in the account currency where the viewer may see money (D8). */
export function OpenPnl({ mark, tz, stacked = true }: { mark: TradeMark | null | undefined; tz: string; stacked?: boolean }) {
  if (!mark) return <span className="text-xs text-muted">no delayed price</span>;
  return (
    <span className={cx('flex gap-x-2', stacked ? 'flex-col items-end' : 'flex-wrap items-baseline')}>
      <span className={cx('font-mono font-semibold whitespace-nowrap', signClass(mark.r ?? mark.pct))}>
        {mark.r !== null ? fmtR(mark.r) : `${Number(mark.pct) > 0 ? '+' : ''}${mark.pct} %`}
        {mark.money && mark.pnl && mark.currency ? <span className="font-normal"> · {formatMoney(mark.pnl, mark.currency, { signed: true })}</span> : null}
      </span>
      <PriceLabel mark={mark} tz={tz} />
    </span>
  );
}
